(() => {
  if (window.AuremeAccountShared) return;

  const SECTION_SELECTOR = '.aureme-account';

  /**
   * DOMContentLoaded + shopify:section:load の共通初期化ボイラープレート
   * @param {(section: HTMLElement) => void} initSectionFn - セクション単位の初期化関数
   */
  function registerSectionInit(initSectionFn) {
    function init(root) {
      for (const section of (root || document).querySelectorAll(SECTION_SELECTOR)) {
        initSectionFn(section);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  }

  window.AuremeAccountShared = {
    sectionSelector: SECTION_SELECTOR,
    storageKeys: {
      point: 'sanyo_app_current_point_',
      rankId: 'sanyo_app_current_rank_id_',
      rankName: 'sanyo_app_current_rank_name_',
      expire: 'sanyo_app_expire_date_',
    },
    registerSectionInit,
  };
})();
